import { api } from "@/api"
import { useQuery } from "@tanstack/vue-query"
import type { MaybeRef } from "@vueuse/core"
import type { CashierResponse } from "../sharedTypes/cashiers"

const listCashiers = async (): Promise<
  CashierResponse[]
> => {
  const response =
    await api.get<CashierResponse[]>("/cashiers/")
  return response.body
}

export type CashierFilters = Partial<{
  search: string
}>

export const useCashiers = (
  filters: MaybeRef<CashierFilters> = {}
) => {
  const { data: allCashiers, ...useQueryReturns } =
    useQuery({
      queryKey: [BASE_CASHIERS_QUERY_KEY],
      queryFn: () => listCashiers(),
      staleTime: 60 * 60 * 1000,
    })

  const getById = (
    id: MaybeRef<string | null | undefined>
  ) =>
    computed(() => {
      if (!unref(id)) return
      if (data.value === undefined) return

      return data.value.find(
        (cashier) => cashier.id === unref(id)
      )
    })

  const data = computed(() => {
    if (!allCashiers.value) return []
    const sorted = [...allCashiers.value].sort((a, b) =>
      a.username.localeCompare(b.username)
    )
    const search = unref(filters).search
    const searched = search
      ? searchBy(sorted, ["username"], search)
      : sorted
    return searched
  })

  return {
    data: data,
    ...useQueryReturns,
    getById,
  }
}
